<div class="flex flex-row gap-2">
    <tran-application-status-badge [status]="status()" />
    <div class="text-xl leading-6 align-items-center">
        {{ `applications.status.${status().toUpperCase()}` | translate }}
    </div>
</div>
